
<template>
    <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6534_8063)">
<path d="M19.0001 14C19.0001 14.2652 18.8947 14.5196 18.7072 14.7071C18.5196 14.8946 18.2653 15 18.0001 15H14.0001C13.7348 15 13.4805 14.8946 13.293 14.7071C13.1054 14.5196 13.0001 14.2652 13.0001 14C13.0001 13.7348 13.1054 13.4804 13.293 13.2929C13.4805 13.1054 13.7348 13 14.0001 13H18.0001C18.2653 13 18.5196 13.1054 18.7072 13.2929C18.8947 13.4804 19.0001 13.7348 19.0001 14ZM29.0001 9V25C29.0001 25.5304 28.7893 26.0391 28.4143 26.4142C28.0392 26.7893 27.5305 27 27.0001 27H5.00006C4.46963 27 3.96092 26.7893 3.58585 26.4142C3.21077 26.0391 3.00006 25.5304 3.00006 25V9C3.00006 8.46957 3.21077 7.96086 3.58585 7.58579C3.96092 7.21071 4.46963 7 5.00006 7H10.0001V6C10.0001 5.20435 10.3161 4.44129 10.8787 3.87868C11.4413 3.31607 12.2044 3 13.0001 3H19.0001C19.7957 3 20.5588 3.31607 21.1214 3.87868C21.684 4.44129 22.0001 5.20435 22.0001 6V7H27.0001C27.5305 7 28.0392 7.21071 28.4143 7.58579C28.7893 7.96086 29.0001 8.46957 29.0001 9ZM12.0001 7H20.0001V6C20.0001 5.73478 19.8947 5.48043 19.7072 5.29289C19.5196 5.10536 19.2653 5 19.0001 5H13.0001C12.7348 5 12.4805 5.10536 12.293 5.29289C12.1054 5.48043 12.0001 5.73478 12.0001 6V7ZM27.0001 14.2013V9H5.00006V14.2013C8.37534 16.0385 12.1572 17.0007 16.0001 17C19.843 17.0007 23.6248 16.0385 27.0001 14.2013Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_6534_8063">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>

  </template>
  
  <script>
  export default {
    props: {
      size: { type: String }
    }
  }
  </script>